import React from "react";
import { Helmet } from "react-helmet";

export function SeoHelper({
                              uri = "",
                              title = null,
                              description,
                              noindex = false,
                              primaryKeywords =
                              "worship song planning, worship setlist builder, church worship planning tool, scripture-based worship, lectionary song planner, church music curation",
                              secondaryKeywords = "",
                          }) {
    const keywords = `${primaryKeywords}${
        secondaryKeywords ? `, ${secondaryKeywords}` : ""
    }`;

    const canonicalUrl = `https://theworshipbible.church${uri}`;

    const env = window.env?.ENVIRONMENT || "production";

    const shouldNoIndex =
        noindex || env === "staging" || env === "local";

    const baseTitle =
        "The Worship Bible | Create Worship Song Flows from Scripture, Themes & Lectionary";

    const siteName = "The Worship Bible";

    const resolvedTitle =
        title || window.__SEO_TITLE__ || null;

    // 🔥 prevent leakage between navigations
    window.__SEO_TITLE__ = null;

    const fullTitle = resolvedTitle
        ? `${resolvedTitle} | ${siteName}`
        : baseTitle;

    return (
        <Helmet>
            {/* Canonical ONLY on production */}
            {env === "production" && (
                <link rel="canonical" href={canonicalUrl}/>
            )}

            {/* Title */}
            <title>{fullTitle}</title>

            {/* Description */}
            {description && (
                <meta name="description" content={description}/>
            )}

            {/* Robots */}
            <meta
                name="robots"
                content={shouldNoIndex ? "noindex, nofollow" : "index, follow"}
            />

            {/* Extra safety */}
            {shouldNoIndex && (
                <meta name="googlebot" content="noindex, nofollow"/>
            )}

            {/* Keywords */}
            <meta name="keywords" content={keywords}/>

            {/* Structured data ONLY on production */}
            {env === "production" && (
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        name: "The Worship Bible",
                        url: canonicalUrl,
                        ...(description ? {description} : {}),
                        ...(keywords ? {keywords} : {}),
                    })}
                </script>
            )}
        </Helmet>
    );
}
